import { TRANSLATIONS_SETTINGS } from '../translations/settings';
import { IDropzoneValidator, IFileUploaderValidator } from './../interfaces/fileUploaderContainer';
import { INTEGRATIONS_ROUTE, ACCOUNT_ROUTE, NEW_CHANGE_ORGANIZATION_ROUTE } from './auth';
import { PERMISSIONS } from './permissions';

export const AVATAR_IMAGE_UPLOADER_VALIDATORS: IFileUploaderValidator = {
  maxFileCount: 1,
  maxFileSize: 1048576 * 2,
  fileFormats: ['jpg', 'jpeg', 'png']
};

export const BUSINESS_IMAGE_UPLOADER_VALIDATORS_NE: IDropzoneValidator = {
  maxFileCount: 1,
  maxFileSize: 1048576, // 1MB
  fileFormats: {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg']
  }
};

export const SETTINGS_OPTION_MENU_NE = [
  {
    id: 4,
    label: TRANSLATIONS_SETTINGS.pageLayout.account,
    permissionsRequired: [PERMISSIONS['MENU_ROOT']['SETTINGS_ROOT']['PROFILE']],
    pathName: ACCOUNT_ROUTE
  },
  {
    id: 0,
    label: TRANSLATIONS_SETTINGS.pageLayout.organization,
    permissionsRequired: [PERMISSIONS['MENU_ROOT']['SETTINGS_ROOT']['ORGANIZATION']],
    pathName: NEW_CHANGE_ORGANIZATION_ROUTE
  },
  {
    id: 3,
    label: TRANSLATIONS_SETTINGS.pageLayout.integrations,
    permissionsRequired: [PERMISSIONS['MENU_ROOT']['SETTINGS_ROOT']['INTEGRATIONS']],
    pathName: INTEGRATIONS_ROUTE
  }
];

export const COMPANIES_UNTIL_PAGINATION = 15;
export const DEFAULT_PAGINATOR_STATE = 15;
export const DEFAULT_PAGINATOR_OPTIONS = [15, 25, 50];
export const DEFAULT_PAGINATOR_OPTIONS_V3 = [50, 100, 150];
